import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PasswordResetForm } from '../components';
import { useAuth } from '../contexts/AuthContext';
import './ResetPasswordPage.css';

const ResetPasswordPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  // Redirect if already authenticated
  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  // Redirect if no token provided
  React.useEffect(() => {
    if (!token || !token.trim()) {
      navigate('/forgot-password');
    }
  }, [token, navigate]);

  const handleSuccess = () => {
    // Success is handled within the component
    // User will see success message and be redirected to login
  };

  const handleBackToLogin = () => {
    navigate('/login');
  };

  if (!token || !token.trim()) {
    return null; // Will redirect via useEffect
  }

  return (
    <div className="reset-password-page">
      <div className="reset-password-container">
        <PasswordResetForm
          onSuccess={handleSuccess}
          onBackToLogin={handleBackToLogin}
        />
      </div>
    </div>
  );
};

export default ResetPasswordPage;
